import { TimesheetEntry, TimesheetEntryType } from '@sdk/timesheets/types/TimesheetEntry';

/**
 * Each Time Clock block (everything that happens between clock in and clock out) is treated separately.
 * This means automated break rules are applied individually and so.
 *
 * This method helps with the extraction of relevant blocks out of all the available blocks.
 */
export const getRelevantTimesheetEntries = (
  timesheetEntries: TimesheetEntry[],
  clockIn: Date,
  clockOut?: Date
) => {
  // Find the relevant start and end of timesheetEntries based on clock in and clock out times
  const relevantStartIndex = timesheetEntries.findIndex(
    entry =>
      entry.type === TimesheetEntryType.clockIn && entry.timestamp.toString() === clockIn.toString()
  );

  let relevantEndIndex = timesheetEntries.length;

  if (clockOut) {
    relevantEndIndex =
      timesheetEntries.findIndex(
        entry =>
          entry.type === TimesheetEntryType.clockOut &&
          entry.timestamp.toString() === clockOut.toString()
      ) + 1;
  }

  // Prepare relevant timesheetEntries
  return timesheetEntries.slice(relevantStartIndex, relevantEndIndex);
};
